import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import { GetResitPaymentTransaction, GetResitReceiptSummary } from '../models';
import { ResitDownloadSummary } from '../../../../../models/@candidate/candidateResitRegistrationSchema';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/resit`;
const timeout = 5000;

export const resitClient = axiosFactory(baseURL, timeout);

/** to get the payment transaction
 * */
export const getCandidateResitRegisterPayment = (internalTransactionRef: string) =>
  resitClient.get<GetResitPaymentTransaction>(
    `${ROUTES.GET_CANDIDATE_RESIT_TRANSACTION}/${internalTransactionRef}`
  );

/** to get resit receipt summary
 * */
export const getResitReceiptSummary = (internalTransactionRef: string) =>
  resitClient.get<GetResitReceiptSummary>(
    `${ROUTES.GET_RESIT_RECEIPT_SUMMARY}/${internalTransactionRef}`
  );

/** get candidate resit download summary s3 pre-signed url */
export const getCandidateDownloadSummary = (internalTransactionRef: string) =>
  resitClient.get<ResitDownloadSummary>(
    ROUTES.GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY(internalTransactionRef),
    {
      timeout: 10000,
    }
  );
